<script setup lang="ts">


</script>
<template>
    <header>
        <div class="container flex j-between">
            <img class="logo" src="/logo-vector-new.svg" alt="">
            <nav class="i-flex a-center gap-10">
                <label class="search i-flex a-center rel">
                    <input type="text" placeholder="Search...">
                    <span class="icon-search abs"></span>
                </label>
                <span class="icon-user"></span>
                <span class="icon-options"></span>
                
            </nav>
        </div>
    </header>  
</template>

<style scoped>
@import '../assets/styles/frontpage_new.css';

</style>